import { Helpers } from '../../helpers';
import { IMajorMilestone } from '../../interfaces/imajor-milestone';
import { MajorMilestoneProjectTypeVisibility } from '../major-milestone-project-type-visibility';
import { MajorMilestoneType } from '../major-milestone-type';
import { ScheduleActivityMajorMilestone } from '../schedule-activity-major-milestone';

export class MajorMilestoneBase {
  MajorMilestoneId: number;
  MajorMilestoneName: string | null;
  DatePoint: number | null;
  MajorMilestoneTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  MajorMilestoneProjectTypeVisibilities_MajorMilestone?: Array<MajorMilestoneProjectTypeVisibility> | null;
  ScheduleActivityMajorMilestones_MajorMilestone?: Array<ScheduleActivityMajorMilestone> | null;
  MajorMilestoneType?: MajorMilestoneType;

  constructor(item?: IMajorMilestone) {
    if (item) {

      this.MajorMilestoneId = item.MajorMilestoneId;
      this.MajorMilestoneName = item.MajorMilestoneName;
      this.DatePoint = item.DatePoint;
      this.MajorMilestoneTypeId = item.MajorMilestoneTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.MajorMilestoneProjectTypeVisibilities_MajorMilestone = Helpers.createClassArray(MajorMilestoneProjectTypeVisibility, item.MajorMilestoneProjectTypeVisibilities_MajorMilestone);
      this.ScheduleActivityMajorMilestones_MajorMilestone = Helpers.createClassArray(ScheduleActivityMajorMilestone, item.ScheduleActivityMajorMilestones_MajorMilestone);
      this.MajorMilestoneType = new MajorMilestoneType(item.MajorMilestoneType);
    }
  }
}